import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { PageRoutes } from "../../../constants/routes";
import { Link } from "../../atoms/Link";
import { LoginForm } from "../../organisms/form/LoginForm";
import { useLogin } from "./hook";

export const Login: React.FC = () => {
  const { handleLogin } = useLogin();

  return (
    <Container>
      <TitleWrapper>ログイン</TitleWrapper>
      <LoginWrapper>
        <LoginForm handleSubmit={handleLogin} />

        <Wrapper>
          <LinkWrapper>
            <Link
              color={BASIC_DARK_GRAY}
              text="パスワードをお忘れの方はこちら"
              size="md"
              fontFamily="Hiragino Sans"
              fontWeight={500}
              href={PageRoutes.FORGOT_PASSWORD}
            />
          </LinkWrapper>
          <LinkWrapper>
            <Link
              color={BASIC_DARK_GRAY}
              text="新規会員登録はこちら"
              size="md"
              fontFamily="Hiragino Sans"
              fontWeight={500}
              href={PageRoutes.CUSTOMER_INFO}
            />
          </LinkWrapper>
        </Wrapper>
      </LoginWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  margin: 0 auto;
  padding-bottom: 85px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.p`
  font-size: 20px;
  padding-top: 41px;
  font-weight: 500;
  line-height: 1;
  display: flex;
  justify-content: center;
  font-family: "Hiragino Sans";
`;

const Wrapper = styled.div`
  overflow: hidden;
`;

const LoginWrapper = styled.div`
  margin: 40px 16px 0 16px;
`;

const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  font-size: 16px;
  margin-top: 30px;
`;
